import { queryOptions, useQuery } from "@tanstack/react-query";

import type { ConversationSource } from "~/conversations/types/conversation";
import type { GetConversationSourcesParams } from "~/conversations/api/get-conversation-sources";
import { getConversationSources } from "~/conversations/api/get-conversation-sources";

function getConversationSourcesQueryOptions(
  params: GetConversationSourcesParams,
) {
  return queryOptions({
    enabled: params.conversationId !== undefined,
    queryKey: ["conversations", "sources", ...Object.entries(params)],
    async queryFn() {
      return await getConversationSources(params);
    },
  });
}

function useGetConversationSources<TSelect = ConversationSource[]>(
  params: GetConversationSourcesParams,
  select?: (data: ConversationSource[]) => TSelect,
) {
  return useQuery({
    ...getConversationSourcesQueryOptions(params),
    select,
  });
}

export { getConversationSourcesQueryOptions, useGetConversationSources };
